<template>
  <div class="relative data-area">
    <Spin fix v-if="loading"></Spin>
    <h1>融资详情</h1>
    <br>
    <Row :gutter="16">
      <Col span="18">
        <h3>融资企业信息</h3>
        <br>
        <Row>
          <Col span="8">
            <span class="label">企业名称：</span>
            <span class="isblock">{{detailInfo.corpNameHold}}</span>
          </Col>
          <Col span="8">
            <span class="label">证件类型：</span>
            <span class="isblock">营业执照(三证合一)</span>
          </Col>
          <Col span="8">
            <span class="label">证件号码：</span>
            <span class="isblock">{{detailInfo.socialCreditCode}}</span>
          </Col>
        </Row>
        <br>
        <Row>
          <Col span="8">
            <span class="label">法人代表：</span>
            <span>{{detailInfo.personNameLegal}}</span>
          </Col>
          <Col span="8">
            <span class="label">法人证件类型：</span>
            <span class="isblock">{{idTypeLegalObj[detailInfo.idTypeLegal]}}</span>
          </Col>
          <Col span="8">
            <span class="label">法人证件号码：</span>
            <span class="isblock">{{detailInfo.idCodeLegal}}</span>
          </Col>
        </Row>
        <br>
        <h3>债权信息</h3>
        <br>
        <Row>
          <Col span="8">
            <span class="label">债权编号：</span>
            <span class="isblock">{{detailInfo.fkCredit}}</span>
          </Col>
          <Col span="8">
            <span class="label">债权金额(元)：</span>
            <span class="isblock">{{detailInfo.maturityAmount | currency}}</span>
          </Col>
          <Col span="8">
            <span class="label">核心企业：</span>
            <span class="isblock">{{detailInfo.corpNameCore}}</span>
          </Col>
        </Row>
        <br>
        <Row>
          <Col span="8">
            <span class="label">转让方：</span>
            <span class="isblock">{{detailInfo.corpNameHold}}</span>
          </Col>
          <Col span="8">
            <span class="label">承诺付款日期：</span>
            <span class="isblock">{{detailInfo.maturityDateString}}</span>
          </Col>
          <Col span="8">
            <span class="label">签收日期：</span>
            <span class="isblock">{{detailInfo.acceptTimeString}}</span>
          </Col>
        </Row>
        <br>
        <h3>融资信息</h3>
        <br>
        <Row>
          <Col span="8">
            <span class="label">申请日期：</span>
            <span class="isblock">{{detailInfo.applyTimeString}}</span>
          </Col>
          <Col span="8">
            <span class="label">资金方：</span>
            <span class="isblock">{{detailInfo.financeShortname}}</span>
          </Col>
          <Col span="8">
            <span class="label">资金方利率：</span>
            <span class="isblock">{{detailInfo.financeInterestRateString}}</span>
          </Col>
        </Row>
        <br>
        <Row>
          <Col span="8">
            <span class="label">资金方费率：</span>
            <span class="isblock">{{detailInfo.financeFeeRateString}}</span>
          </Col>
          <Col span="8">
            <span class="label">融资状态：</span>
            <span class="isblock c-red">{{creditStatusObj[detailInfo.creditState]}}</span>
          </Col>
          <Col span="8">
            <span class="label">放款日期：</span>
            <span class="isblock">{{detailInfo.loanTimeString}}</span>
          </Col>
        </Row>
        <br>
        <Row>
          <Col span="8">
            <span class="label">放款入账金额(元)：</span>
            <span class="isblock">{{detailInfo.loanAmountString}}</span>
          </Col>
          <Col span="8"></Col>
          <Col span="8"></Col>
        </Row>
        <br>
        <h3>商务合同信息</h3>
        <br>
        <Table stripe :loading="contract_loading" :columns="contract_columns" :data="contract_data"></Table>
        <br>
        <Page :total="contract_pagecond.count" :current="contract_pagecond.page" :page-size="contract_pagecond.pageSize" @on-change="contract_changePage"
          @on-page-size-change="contract_changePageSize" show-elevator show-total show-sizer size="small">
        </Page>
        <br>
        <h3>发票信息</h3>
        <br>
        <div><span>发票笔数：{{invoice_pagecond.count}}</span><span class="ml20">价税合计金额(元) ：{{invoice_info.invoiceAmountTotal | currency}}</span><span class="ml20">转让总额(元) ：{{invoice_info.loanAmountTotal | currency}}</span></div>
        <br>
        <Table stripe :loading="invoice_loading" :columns="invoice_columns" :data="invoice_data"></Table>
        <br>
        <Page :total="invoice_pagecond.count" :current="invoice_pagecond.page" :page-size="invoice_pagecond.pageSize" @on-change="invoice_changePage"
          @on-page-size-change="invoice_changePageSize" show-elevator show-total show-sizer size="small">
        </Page>
      </Col>
      <Col span="6" class="single-credit-detail">
        <h3>
          <Row>
            <Col span="14">
              <span class="fs-16">融资材料信息</span>
            </Col>
            <Col span="10" class="tar">
              <Button type="primary" @click="downloadFiles">下载全部</Button>
            </Col>
          </Row>
        </h3>
        <br>
        <Tree :data="treeData"></Tree>
      </Col>
    </Row>
    <Row class="mt20 table-bottom">
      <Col span="24" class="tac">
        <Button type="primary" @click="$router.go(-1)" class="btn current">返回</Button>
      </Col>
    </Row>
  </div>
</template>

<script>
import Vue from 'vue'
import ajax from '@/libs/ajax'
import config from '@/config/index'
import downloadService from '@/libs/download-file'
export default {
  name: 'finance-finance-detail',
  created(){
    this.loading = true;
    this.getDetail();
    this.getContract('init');
    this.getInvoice('init');
    this.getTreeList();
  },
  data(){
    return {
      loading:false,
      credit_loading: false,
      tree_loading: false,
      isShow:false,
      contract_loading:false,
      contract_columns:[
        {
          title: "序号",
          type: "index",
          width: 65,
          align: 'center'
        },
        {
          title: "合同名称",
          key: "busiContractName"
        },
        {
          title: "合同编号",
          key: "busiContractNumber"
        },
        {
          title: "合同金额(元)",
          render: (h, params) => {
            return h('span', Vue.filter('currency')(params.row.busiContractAmount))
          }
        },
        {
          title: "签订日期",
          key: "signDateString"
        }
      ],
      contract_data:[],
      contract_pagecond: {
        count: 0,
        page: 1,
        pageSize: 10
      },
      invoice_loading:false,
      invoice_columns:[
        {
          title: "序号",
          type: "index",
          width: 65,
          align: 'center'
        },
        {
          title: "发票类型",
          render: (h, params) => {
            return h('span', this.invoiceTypeObj[params.row.invoiceType])
          }
        },
        {
          title: "发票代码",
          key: "invoiceCode"
        },
        {
          title: "发票号码",
          key: "invoiceNumber"
        },
        {
          title: "开票日期",
          key: "invoiceDateString"
        },
        {
          title: "价税合计(元)",
          render: (h, params) => {
            return h('span', Vue.filter('currency')(params.row.invoiceAmount));
          }
        },
        {
          title: "转让金额(元)",
          render: (h, params) => {
            return h('div', Vue.filter('currency')(params.row.relatedAmount));
          }
        }
      ],
      invoice_data:[],
      invoice_info:{},
      invoice_pagecond: {
        count: 0,
        page: 1,
        pageSize: 10
      },
      treeData:[],
      detailInfo:{},
      idTypeLegalObj: window.CCBSCF_ENUM_OBJ.PERSON_AUTHENTICATION_TYPE,
      invoiceTypeObj: window.CCBSCF_ENUM_OBJ.INVOICE_TYPE,
      creditStatusObj: window.CCBSCF_ENUM_OBJ.CREDIT_STATE,
      fkCredit: this.$route.query.fkCredit || '',
      imageReg: /\.(gif|jpg|jpeg|png|GIF|JPG|PNG)$/,
      pdfReg: /\.(pdf|PDF)$/
    }
  },
  methods:{
    contract_changePage(v) {
      this.contract_pagecond.page = v;
      this.getContract();
    },
    contract_changePageSize(v) {
      this.contract_pagecond.pageSize = v;
      this.getContract();
    },
    invoice_changePage(v) {
      this.invoice_pagecond.page = v;
      this.getInvoice();
    },
    invoice_changePageSize(v) {
      this.invoice_pagecond.pageSize = v;
      this.getInvoice();
    },
    getDetail(){
      this.credit_loading = true
      ajax.get(`/fin/v1/credits/asset/${this.fkCredit}/detail`).then((res) => {
        this.credit_loading = false
        if (res.code == 0) {
          if(!this.tree_loading) {
            this.loading = false
          }
          this.detailInfo = res.data
        } else {
          this.loading = false
          this.$Tip.warning({
            content:res.message
          })
        }
      }).catch(err => {
        this.credit_loading = false
        this.loading = false
        this.$Tip.error({
          content:err.message
        })
      });
    },
    getContract(str){
      this.contract_loading = true
      if (str) {
        this.contract_pagecond.page = 1
        this.contract_pagecond.pageSize = 10
      }
      ajax.get(`/fin/v1/credits/asset/${this.fkCredit}/contract`,{
        params: {
          page: this.contract_pagecond.page,
          pageSize: this.contract_pagecond.pageSize,
        }
      }).then((res) => {
        this.contract_loading = false
        if (res.code == 0) {
          this.contract_data = res.data.datalist
          this.contract_pagecond = res.data.pagecond
        } else {
          this.$Tip.warning({
            content:res.message
          })
        }
      }).catch(err => {
        this.contract_loading = false
        this.$Tip.error({
          content:err.message
        })
      });
    },
    getInvoice(str){
      this.invoice_loading = true
      if (str) {
        this.invoice_pagecond.page = 1
        this.invoice_pagecond.pageSize = 10
      }
      ajax.get(`/fin/v1/credits/asset/${this.fkCredit}/invoice`,{
        params: {
          page: this.invoice_pagecond.page,
          pageSize: this.invoice_pagecond.pageSize,
        }
      }).then((res) => {
        this.invoice_loading = false
        if (res.code == 0) {
          this.invoice_data = res.data.datalist
          this.invoice_info = res.data
          this.invoice_pagecond = res.data.pagecond
        } else {
          this.$Tip.warning({
            content:res.message
          });
        }
      }).catch(err => {
        this.invoice_loading = false
        this.$Tip.error({
          content:err.message
        });
      });
    },
    getTreeList(){
      ajax.get(`/fin/v1/credits/finance/docs/tree`,{
        params: {
          pkCredit: this.fkCredit
        }
      }).then((res) => {
        this.tree_loading = false
        if (res.code == 0) {
          if(!this.credit_loading) {
            this.loading = false
          }
          this.treeData = this.treeFormat([res.data])
        } else {
          this.$Tip.warning({
            content:res.message
          });
        }
      }).catch(err => {
        this.tree_loading = false;
        this.loading = false;
        this.$Tip.error({
          content:err.message
        });
      });
    },
    // 递归树格式化
    treeFormat(tree,files){
      var _this = this
      var treeList = []
      if(tree){
        tree.forEach(function(item){
          treeList.push({
              title: item.title,
              expand: true,
              render: (h, { root, node, data }) => {
                var spans = [];
                spans.push(h('img',
                  {
                    attrs: {
                      src: require('./images/folder.png')
                    },
                    style: {
                      padding: '0 5px 0 0'
                    }
                  })
                );
                spans.push(h('span',
                  {
                    style: {
                      cursor: 'pointer'
                    }
                  }, data.title)
                );
                return spans
              },
              children: _this.treeFormat(item.child,item.files)
            })
          })
      }
      if(files){
        files.forEach(function(file){
          treeList.push({
            fkCredit: file.fkCredit,
            title: file.fileName,
            fkFile: file.fkFile,
            render: (h, { root, node, data }) => {
              var spans = [];
              spans.push(h('img',
                {
                  attrs: {
                    src: require(`./images/${_this.judgeFileFormat(data.title)}.png`)
                  },
                  style: {
                    padding: '0 5px 0 0'
                  }
                })
              );
              spans.push(h('span',
                {
                  style: {
                    cursor: 'pointer',
                    whiteSpace: 'normal',
                    wordBreak: 'break-all'
                  },
                  on: {
                    click: () => {
                      _this.clickFile(data)
                    }
                  }
                }, data.title)
              );
              return spans
            }
          })
        })
      }
      return treeList
    },
    // 选择树节点
    clickFile(v){
      if(v.fkFile){
        window.open(config.baseUrl + '/fin/v1/files/'+v.fkFile+'/preview')
      }
    },
    // 下载文件包
    downloadFiles () {
      downloadService.saveFile(config.baseUrl + '/fin/v1/credits/finance/docs/download', {
        pkCredit: this.fkCredit
      })
    },
    // 判断文件格式
    judgeFileFormat (fileName) {
      let imageName = 'img'
      if (this.imageReg.test(fileName)) {
        imageName = 'img'
      } else if (this.pdfReg.test(fileName)) {
        imageName = 'pdf'
      } else {
        imageName = 'img'
      }
      return imageName
    }
  }
}
</script>


<style lang="less" scoped>
.data-area span.label{
  width: 130px !important;
  display: block;
  float: left;
}
.relative{
  position: relative;
}
.isblock{
  display: block;
  margin-left: 130px;
  vertical-align: top;
}
.single-credit-detail{
  /deep/ .ivu-tree {
    overflow: auto;
    .ivu-tree-children .ivu-tree-arrow {
      width: auto;
    }
  }
}
</style>
